// import discoveryApi from '@/api/modules/api-discovery'
// import * as types from './mutation-types'

// 初始化数据 --> mapStates
const state = ()=>({
})

// 衍生数据，追踪数据更新后值 --> mapGetters
const getters = {
}

// mutations，同步数据，vue视图文件中可用this.$store.commit
const mutations = {
}

// actions， 异步操作数据，vue视图文件中可用this.$store.dispatch
const actions = {
  /**
   * 获取热门股单风口信息
   */
  // getTuyereDetail({ commit }, params) {
  //   return new Promise((resolve) => {
  //     discoveryApi.getTuyereDetail(params).then(res => {
  //       commit()
  //       resolve(res)
  //     }).catch(err => {
  //       console.log(err)
  //     })
  //   })
  // }
}

export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions
}